exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3mW2{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_3mW2",
	"root": "_3mW2"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/Footer/Footer.css
// module id = 181
// module chunks = 0